<template>
  <app-modal name="create-invoice-form-modal" :title="title" @before-open="beforeOpen" hide-footer
    @before-close="beforeClose" width="90%">
    <div class="row create-invoice-form-modal">
      <button class="btn btn-block ml-2 mb-3" style="width: 25%; background-color: #005DCA; color: white;"
        @click="onClickGetTemplate">Lấy mẫu hóa đơn đầu
        vào</button>
      <div class="col-md-12 invoice-form">
        <create-invoice-form ref="form" :seller-setting-list="sellerSettingList"
          @on-change-currency-code="onChangeCurrencyCode" @on-change-invoice-type="onChangeInvoiceType"
          @on-input-modified="invoiceDataChanged" />
        <dynamic-table ref="table" :data="tableData" :currency-code="currencyCode" :invoiceType="invoiceType"
          :seller-setting-list="sellerSettingList" @onTableChange="tableChangeHandler" />
      </div>
      <div class="col-md-12 text-right pt-3 pr-4">
        <button :disabled="isLoading" @click="onClickPreview" class="btn btn-outline-primary btn-sm">
          {{ this.$t('app.preview') }}
        </button>
        <button :disabled="isLoading" @click="onClickSaveDraft" class="btn btn-outline-primary btn-sm ml-2">
          Lưu nháp
        </button>
        <app-btn-submit :is-submitting="isLoading" :css="'btn btn-primary btn-sm ml-2'" :text="$t('invoice.issued')"
          @on-click="onClickSave" />
      </div>
    </div>
  </app-modal>
</template>
<script>
import { mapState } from 'vuex';
import ToastUtils from '@/utils/toast';
import { PRODUCT_TYPE, INVOICE_PRODUCT_SERVICE_TABLE_ERROR } from '@/app-constant';
import { handleDataBuyer, normalizeLineTotals } from '@/utils/invoice';
import AppModal from '@/components/app-modal/';
import DynamicTable from '@/components/dynamic-table/dynamic-table';
import CreateInvoiceForm from '@/portal-components/invoice/create-invoice-form';
import AppBtnSubmit from '@/components/app-button/index';
import ReleaseInvoiceMixin from '@/mixins/release-invoice';
import EInvoiceProxy from '@/store/proxies/e-invoice/e-invoice-proxy';
import ProductProxy from '@/store/proxies/product-proxy';
import ProductCategoryProxy from '@/store/proxies/product-category-proxy';

const vatInvoice = '1';
const VND = 'VND';
const DEFAULT_PRODUCT_CATEGORY_NAME = 'HÀNG HÓA';



const initData = (ctx) => ({
  isMobile: false,
  title: ctx.$t('invoice.createNewInvoice'),
  file_name: null,
  isLoading: false,
  tableData: [{
    id: 0,
    stt: null,
    name: null,
    unit: '',
    quantity: null,
    price: null,
    rate: 'NONE',
    tax_money: null,
    subtotal: null,
    total: null,
    type: PRODUCT_TYPE.PRODUCT,
    custom_tax_rate: 0,
    method: null,
  }],
  invoiceType: vatInvoice,
  currencyCode: VND,
  invoiceHasChanged: false,
  defaultProductCategoryIdPromise: null
});

export default {
  name: 'CreateInvoiceFormModal',
  mixins: [ReleaseInvoiceMixin],
  components: {
    AppBtnSubmit,
    CreateInvoiceForm,
    DynamicTable,
    AppModal,
  },
  data() {
    return initData(this);
  },
  created() {
    this.$bus.on('create-invoice', this.onClickSave);
    this.$bus.on('autofill-products-from-template', this.autoFillProductsFromTemplate)
    this.$bus.on('close-create-invoice-modal', this.onCancel)
    this.MISSING_DATA_ERROR = INVOICE_PRODUCT_SERVICE_TABLE_ERROR(this)
  },
  beforeDestroy() {
    this.$bus.off('create-invoice', this.onClickSave);
    this.$bus.off('autofill-products-from-template', this.autoFillProductsFromTemplate)
    this.$bus.off('close-create-invoice-modal', this.onCancel)
  },
  computed: {
    ...mapState(['activeAnnouncementLines', 'sellerSettingList']),
  },
  methods: {
    validateLineItem(tableData) {
      let missingInTable = { // keys are error types and values are table coords [ field, row id ]
        EMPTY_TABLE: false,
        MISSING_NOTE: [],
        MISSING_NAME: [],
        MISSING_DISCOUNT: [],
        MISSING_UNIT: [],
        INVALID_UNIT: [],
        MISSING_QUANTITY: [],
        MISSING_PRICE: [],
      };
      if (!tableData || tableData.length === 0) {
        missingInTable.EMPTY_TABLE = true
        return missingInTable
      }

      for (let i = 0; i < tableData.length; i++) {
        const row = tableData[i];

        if (row.type === PRODUCT_TYPE.NOTE && !row.name) {
          missingInTable.MISSING_NOTE.push(['name', row.id])
        } else if (row.type === PRODUCT_TYPE.DISCOUNT && !row.name) {
          missingInTable.MISSING_DISCOUNT.push(['name', row.id])
        } else if (row.type === PRODUCT_TYPE.PRODUCT) {
          // Tạm không bắt buộc Đơn vị (FE) — để BE xử lý / kiểm tra.
          missingInTable = ['name', 'quantity', 'price'].reduce((acc, k) => {
            const val = row[k];

            if (!val && val !== 0) {
              if (k === 'name') acc.MISSING_NAME.push(['name', row.id]);
              else acc[`MISSING_${k.toUpperCase()}`].push([k, row.id]);
            }

            return acc
          }, missingInTable)
        }
      }
      return missingInTable;
    },
    detectValidationErrors(lines, { bypassUnit = false } = {}) {
      const tableErrorMsg = this.validateLineItem(lines);
      const detectedErrors = Object.entries(tableErrorMsg).reduce((acc, [key, value]) => {
        const hasErrors = (Array.isArray(value) ? value.length > 0 : !!value)
        if (hasErrors) {
          // Bỏ qua lỗi Đơn vị khi cần tạm cho FE đi qua để BE kiểm tra.
          if (bypassUnit && (key === 'INVALID_UNIT' || key === 'MISSING_UNIT')) {
            return acc;
          }
          acc.keys.push(key)
          acc.values.push(...value)
        }
        return acc
      }, {
        keys: [],
        values: []
      })

      if (detectedErrors.keys.length) {
        const { hasInvalidUnit, otherKeys } = detectedErrors.keys.reduce((acc, k) => {
          if (k === 'INVALID_UNIT') acc.hasInvalidUnit = true
          else acc.otherKeys.push(k)
          return acc
        }, {
          hasInvalidUnit: false,
          otherKeys: []
        })

        if (hasInvalidUnit) {
          ToastUtils.showToast('error', 'Đơn vị không hợp lệ. Ví dụ: cái, hộp, thùng, kg,...');
        }

        if (otherKeys.length > 0) {
          const missingFieldsInWords = otherKeys.map(errorType => {
            return this.MISSING_DATA_ERROR[errorType] || errorType;
          });
          ToastUtils.showToast('error', `${missingFieldsInWords.join('/')} không được bỏ trống.`);
        }

        this.$refs.table.forceInvalidateFields(detectedErrors.values);
      }

      return detectedErrors.keys.length
    },
    publishInvoice(formData) {
      const vm = this;
      const payload = {
        ...formData,
        include_info: this.invoiceType === '6',
        ...this.$refs.table.getTotals(),
        lines: this.tableData,
      };
      return new Promise((resolve, reject) => {
        vm.$refs.form.submit();
        vm.$refs.form.validate().then((isValid) => {
          const errorItems = (vm.$validator && vm.$validator.errors && vm.$validator.errors.items)
            ? vm.$validator.errors.items
            : [];
          const bypassFields = ['buyer_name', 'buyer_legal_name'];
          const canBypassUnitValidation = errorItems.length > 0 && errorItems.every(e => bypassFields.includes(e.field));

          // Tạm bỏ validate "Đơn vị" (buyer_name / buyer_legal_name) để BE xử lý.
          if (isValid || canBypassUnitValidation) {
            const hasErrors = this.detectValidationErrors(payload.lines, { bypassUnit: true });
            if (!hasErrors) {
              this.isLoading = true;
              this.saveNewProducts(payload.lines)
                .then(() => this.createAndReleaseInvoice(payload))
                .then((res) => {
                  if (res) {
                    resolve(res);
                  }
                }).catch((error) => { reject(error); });
            }
            return;
          }

          if (errorItems.length > 0) {
            // Thứ tự trong items error dựa vào layout.
            if (
              errorItems.length > 1
              && errorItems[0].field === 'buyer_name'
              && errorItems[1].field === 'buyer_legal_name'
            ) {
              ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
              return;
            }
            ToastUtils.showToast('error', errorItems[0].msg);
          }
        });
      });
    },
    extractList(res) {
      if (Array.isArray(res)) return res;
      if (res && Array.isArray(res.results)) return res.results;
      if (res && Array.isArray(res.data)) return res.data;
      return [];
    },
    getDefaultProductCategoryId() {
      if (this.defaultProductCategoryIdPromise) {
        return this.defaultProductCategoryIdPromise;
      }

      this.defaultProductCategoryIdPromise = new ProductCategoryProxy()
        .list({ page: 1, page_size: 200 })
        .then((res) => {
          const categories = this.extractList(res);
          const defaultCategory = categories.find((item) => {
            const name = (item && item.name ? item.name : '').trim().toLowerCase();
            return name === DEFAULT_PRODUCT_CATEGORY_NAME.toLowerCase();
          });

          if (defaultCategory && defaultCategory.id != null) {
            return defaultCategory.id;
          }

          return new ProductCategoryProxy()
            .create({ name: DEFAULT_PRODUCT_CATEGORY_NAME })
            .then(created => (created && created.id != null ? created.id : null));
        })
        .catch(() => null);

      return this.defaultProductCategoryIdPromise;
    },
    saveNewProducts(invoiceLines = []) {
      const newLines = invoiceLines.filter((line) => {
        if (!line || line.type !== PRODUCT_TYPE.PRODUCT) return false;
        return !!line.name && !line.product_id;
      });

      if (newLines.length === 0) return Promise.resolve();

      const defaultCategoryIdPromise = this.getDefaultProductCategoryId();
      const savePromises = newLines.map((line) => {
        const categoryIdPromise = line.category_id != null
          ? Promise.resolve(line.category_id)
          : defaultCategoryIdPromise;

        return categoryIdPromise
          .then((categoryId) => new ProductProxy().create({
            name: line.name,
            unit: line.unit || '',
            price: Number(line.price) || 0,
            rate: line.rate === 'KHAC' ? (Number(line.custom_tax_rate) || 0) : (Number(line.rate) || 0),
            type: line.type || 'HANG_HOA',
            category: categoryId || undefined,
          }))
          .then((res) => {
            line.product_id = res && res.id ? res.id : null;
          })
          .catch(() => { });
      });

      return Promise.all(savePromises);
    },
    onCancel() {
      this.initialize();
      setTimeout(() => {
        this.$modal.hide('create-invoice-form-modal', { isOk: true });
      }, 100)
    },
    beforeClose(event) {
      if (this.invoiceHasChanged) {
        event.stop();
        this.$modal.show('save-invoice-draft-modal', {
          text: this.$t('invoice.saveDraftConfirmMsg'),
          okText: 'Lưu nháp',
          okClass: 'btn btn-primary btn-sm',
          cancelText: this.$t('dialog.continue'),
          cancelClass: 'btn btn-danger btn-sm',
          onOk: async () => {
            await this.onClickSaveDraft()
          }
        });
      } else this.initialize();
    },
    initialize() {
      this.invoiceHasChanged = false;
      this.invoiceType = vatInvoice;
      this.isLoading = false;
      this.tableData = [{
        id: 0,
        stt: null,
        name: null,
        unit: '',
        quantity: null,
        price: null,
        rate: 'NONE',
        tax_money: null,
        subtotal: null,
        total: null,
        type: PRODUCT_TYPE.PRODUCT,
        custom_tax_rate: 0,
        method: null,
      }];
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.initialize();
        }
      });
    },
    onClickSave() {
      const vm = this;
      const payload = this.$refs.form.getValues();
      this.publishInvoice(payload).then((res) => {
        if (res) {
          this.initialize();
          ToastUtils.showToast('success', vm.$t('invoice.invoiceIssued'));
          this.$bus.emit('update-invoice-success', { model: res });
          this.$modal.hide('create-invoice-form-modal', { isOk: true });
          this.$router.push({ name: 'main.revenue', params: this.$route.params, query: { ...this.$route.query, statistics: 'HIDE' } }).catch(() => { });
        }
      }, (errorCode) => {
        this.$modal.show('usb-token-error-modal', { model: { error: errorCode, flag: 'CREATE' } });
        this.isLoading = false;
      });
    },
    onClickSaveDraft() {
      const vm = this;
      const formData = this.$refs.form.getValues();
      const payload = {
        ...formData,
        ...this.$refs.table.getTotals(),
        include_info: this.invoiceType === '6',
        lines: this.tableData,
        seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || null,
      };
      vm.$refs.form.submit();
      return vm.$refs.form.validate().then((isValid) => {
        if (isValid) {
          // Nếu chỉ vướng lỗi "Đơn vị" thì tạm cho FE đi qua để BE kiểm tra/ chặn.
          const hasErrors = this.detectValidationErrors(payload.lines, { bypassUnit: true });
          if (hasErrors) return;
          this.isLoading = true;
          this.handleDraftInvoice(payload)
            .then((res) => {
              if (res) {
                this.initialize();
                ToastUtils.showToast('success', 'Tạo hóa đơn nháp thành công');
                this.$bus.emit('update-invoice-success', { model: res });
                this.$modal.hide('create-invoice-form-modal', { isOk: true });
              }
            }, (error) => {
              ToastUtils.showToast('error', error.message);
              this.isLoading = false;
            });
        } else {
          ToastUtils.showToast('error', vm.$validator.errors.items[0].msg);
        }
      }).then(() => {
        if (this.$route.name !== 'main.status.draft') this.$router.push({ name: 'main.status.draft', params: this.$route.params, query: { ...this.$route.query, statistics: 'HIDE' } }).catch(() => { })
      });
    },
    onClickPreview() {
      const vm = this;
      const formData = this.$refs.form.getValues();
      const payload = {
        ...formData,
        ...this.$refs.table.getTotals(),
        lines: this.tableData,
        is_draf_preview: true,
        include_info: this.invoiceType === '6',
        seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || null,
      };
      vm.$refs.form.submit();
      vm.$refs.form.validate().then((isValid) => {
        const errorItems = (vm.$validator && vm.$validator.errors && vm.$validator.errors.items)
          ? vm.$validator.errors.items
          : [];
        const bypassFields = ['buyer_name', 'buyer_legal_name'];
        const canBypassUnitValidation = errorItems.length > 0 && errorItems.every(e => bypassFields.includes(e.field));

        if (isValid || canBypassUnitValidation) {
          const hasErrors = this.detectValidationErrors(payload.lines, { bypassUnit: true });
          if (hasErrors) {
            return;
          }
          this.isLoading = true;
          new EInvoiceProxy().createEInvoice(payload)
            .then((res) => {
              if (res) {
                this.$modal.show('invoice-preview-modal', {
                  pdfURL: `${res.preview_file}`,
                  buyerInfo: handleDataBuyer(formData),
                  invoiceCommonCode: payload.invoice_common_code,
                });
              }
            })
            .catch((error) => { ToastUtils.showToast('error', error.message); })
            .finally(() => {
              this.isLoading = false;
            });
          return;
        }

        if (errorItems.length > 0) {
          if (
            errorItems.length > 1
            && errorItems[0].field === 'buyer_name'
            && errorItems[1].field === 'buyer_legal_name'
          ) {
            ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
            return;
          }
          ToastUtils.showToast('error', errorItems[0].msg);
        }
      });
    },
    beforeOpen() {
      this.$bus.emit('display-invoice-form-model', true);
    },
    tableChangeHandler(data, total_amount_with_tax) {
      this.tableData = data;
      if (total_amount_with_tax !== 0) {
        this.invoiceDataChanged(true);
      } else this.invoiceDataChanged(false);
    },
    onChangeInvoiceType(invoiceType) {
      this.invoiceType = invoiceType;
    },
    onChangeCurrencyCode(currencyCode) {
      this.currencyCode = currencyCode;
    },
    onClickGetTemplate() {
      this.$modal.show('get-template-modal', { model: {} });
    },
    invoiceDataChanged(value) {
      this.invoiceHasChanged = value
    },
    autoFillProductsFromTemplate(products) {
      products = JSON.parse(products);
      if (!products || !products.length) return;

      const tableData = [...this.tableData];
      const tableLength = tableData.length;

      const mappedProducts = products.map((item, index) => {
        const { subTotalInFloat, taxMoneyInFloat, maxTotals, rate } = normalizeLineTotals(item);
        const hasProductType = item.PRODUCT_TYPE && item.PRODUCT_TYPE.length > 0;

        return {
          id: index + tableLength,
          stt: item.PRODUCT_NO || null,
          name: item.PRODUCT_DESC || '',
          unit: item.PRODUCT_UNIT || '',
          type: hasProductType ? item.PRODUCT_TYPE : PRODUCT_TYPE.PRODUCT,
          quantity: parseFloat(item.PRODUCT_QUANTITY) || 0,
          price: parseFloat(item.PRODUCT_UNIT_PRICE) || 0,
          subtotal: subTotalInFloat,
          tax_money: taxMoneyInFloat,
          total: maxTotals,
          custom_tax_rate: 0,
          method: null,
          rate,
        };
      });

      const emptyRowIndex = tableData.findIndex(
        (item) =>
          (!item.name || item.name === '') &&
          (!item.price || item.price === null) &&
          (!item.quantity || item.quantity === null)
      );

      if (emptyRowIndex !== -1) {
        this.$set(tableData, emptyRowIndex, mappedProducts[0]);

        if (mappedProducts.length > 1) {
          mappedProducts.slice(1).forEach((item) => {
            tableData.push(item);
          });
        }
      } else {
        tableData.push(...mappedProducts);
      }

      tableData.forEach((row, idx) => {
        row.id = idx;
      });

      this.tableChangeHandler([...tableData]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/create-invoice-form-modal.vue